module.exports = __webpack_public_path__ + "img/f05d7959f7a6729816184b92b2d6d4fb--tattoo-neck-chest-tattoo.jpg";